import { useEffect, useState } from "react";
import { FetchStatus, LanderCookie } from "../commons/Constants";
import { getCookie } from "../commons/HelperFunctions";
import { getYahooRSUri, yahooXmlFetch } from "./yahooFeed";

interface UseYahooRSKeywordsResult {
  fetchState: number;
  keywords: string[];
}

export function useYahooRSKeywords(
  landerConfig: {
    domain?: { rootDomain: string };
    system: string;
    customerId?: string;
    yahoo?: { typeTag?: string };
  },
  enabled: boolean
): UseYahooRSKeywordsResult {
  const rootDomain = landerConfig.domain?.rootDomain;

  const [fetchState, setFetchState] = useState<number>(
    enabled ? FetchStatus.PENDING : FetchStatus.BLOCKED
  );
  const [keywords, setKeywords] = useState<string[]>([]);

  useEffect(() => {
    if (!enabled || !rootDomain) return;

    if (!getCookie(LanderCookie.CLIENT_IP)) {
      setFetchState(FetchStatus.BLOCKED);
      return;
    }

    let ignore = false;

    const yahooUrl = getYahooRSUri({
      rootDomain,
      system: landerConfig.system,
      customerId: landerConfig.customerId,
      typeTag: landerConfig.yahoo?.typeTag,
    });

    yahooXmlFetch(yahooUrl).then((result) => {
      if (ignore) return;

      if (result.fetchStatus === FetchStatus.SUCCESS && result.xmlResult) {
        const searchElements =
          result.xmlResult
            .getElementById("relatedTerms")
            ?.getElementsByTagName("Search") ?? [];
        const terms = Array.from(searchElements)
          .map((el) => el.innerHTML)
          .filter(Boolean);

        setKeywords(terms);
        setFetchState(
          terms.length > 0 ? FetchStatus.SUCCESS : FetchStatus.FAILURE
        );
      } else {
        setFetchState(FetchStatus.FAILURE);
      }
    });

    return () => {
      ignore = true;
    };
  }, [
    enabled,
    rootDomain,
    landerConfig.system,
    landerConfig.customerId,
    landerConfig.yahoo?.typeTag,
  ]);

  return { fetchState, keywords };
}
